// 售后列表
<template>
  <div class="sld_after_sales_list">
    <MemberTitle :memberTitle="curTitleId == 2 ? L['我的退货'] : L['我的退款']" style="padding-left:20px"></MemberTitle>
    <div class="after_sales_list_main">
      <div class="after_sales_title flex_row_start_center">
        <span class="after_sales_title_pre cursor_pointer" :class="{ active_title: titleItem.titleId == curTitleId }"
              v-for="(titleItem, titleIndex) in afterSalesTitle.data" :key="titleIndex"
              @click="titleNav(titleItem.titleId)">
          {{ titleItem.content }}
        </span>
        <el-checkbox
            v-if="store.state.memberInfo.multipleStoresId !== 0" v-model="showAllStoreOrders" @change="getAfterSalesDet" class="store-checkbox">
          {{ L['显示所有门店售后'] }}
        </el-checkbox>
        <span class="text"  v-if="store.state.memberInfo.multipleStoresId !== 0">
                    温馨提示: 非当前门店订单如要发起售后,请切换至对应门店账号~
        </span>
      </div>

      <div class="after_sales_list">
        <div class="after_sales_list_title flex_row_start_center">
          <div class="title_goods_des">{{ L["商品明细"] }}</div>
          <div class="title_apply_time">{{ L["申请时间"] }}</div>
          <div class="title_apply_type">{{ L["申请类型"] }}</div>
          <div class="title_status">{{ L["状态"] }}</div>
          <div class="title_options">{{ L["操作"] }}</div>
        </div>
        <div class="after_sales_list_con">
          <div class="list_con_pre" v-for="(afterSalesItem, afterSalesIndex) in afterSalesList.data"
               :key="afterSalesIndex">
            <div class="list_con_pre_title flex_row_start_center">
              <p>{{ L["下单时间"] }}：{{ afterSalesItem.applyTime }}</p>
              <p>{{ L["订单号"] }}：{{ afterSalesItem.orderSn }}</p>
              <div class="multiple_stores_name " v-if="showAllStoreOrders && store.state.memberInfo.multipleStoresId !== 0">{{afterSalesItem.companyName}}</div>
              <p class="storeName cursor_pointer" @click="toStore(afterSalesItem.storeId)">{{ afterSalesItem.storeName
                }}</p>

            </div>
            <div class="list_con">
              <div class="list_pre flex_row_start_center">
                <div class="list_goods_des borderRight flex_row_start_center cursor_pointer"
                     @click="goGoodsDetail(afterSalesItem.productId)">
                  <div class="list_goods_img" :style="{
                      backgroundImage:
                        'url(' + afterSalesItem.productImage + ')',
                    }"></div>
                  <div class="goods_des">
                    <p>{{ afterSalesItem.goodsName }}</p>
                    <p>{{afterSalesItem.specValues}}</p>
                  </div>
                </div>
                <div class="list_apply_time borderRight flex_row_center_center">
                  {{ afterSalesItem.applyTime }}
                </div>
                <div class="list_apply_type borderRight flex_row_center_center">
                  {{ afterSalesItem.returnTypeValue }}
                </div>
                <div class="list_status borderRight flex_row_center_center">
                  {{ afterSalesItem.stateValue }}
                </div>
                <div class="list_options flex_column_center_center">
                  <span class="cursor_pointer" @click="goRefundDetail(afterSalesItem)">{{ L["查看详情"] }}</span>
                  <span class="cursor_pointer" v-if="
                      afterSalesItem.returnType == 2 &&
                      afterSalesItem.state == 201
                    " @click="logisticsBill(afterSalesItem)">{{ L["发货"] }}</span>
                </div>
              </div>
            </div>
          </div>
          <SldCommonEmpty v-show="!afterSalesList.data.length" totalWidth="900"></SldCommonEmpty>
          <div class="flex_row_end_center sld_pagination sld_page_bottom" v-if="
              aftersalesDetail.data &&
              aftersalesDetail.data.pagination &&
              aftersalesDetail.data.pagination.total
            ">
            <el-pagination @current-change="handleCurrentChange" v-model:currentPage="current" :page-size="pageSize"
                           layout="prev, pager, next, jumper" :total="aftersalesDetail.data.pagination.total"
                           :hide-on-single-page="true">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive, ref, getCurrentInstance, watchEffect } from "vue";
import { ElMessage, ElPagination } from "element-plus";
import SldCommonEmpty from '../../../components/SldCommonEmpty';
import { useRouter } from "vue-router";
import { useStore } from 'vuex'
import MemberTitle from "../../../components/MemberTitle";

export default {
  components: {
    ElPagination,
    MemberTitle,
    SldCommonEmpty
  },
  setup() {
    const { proxy } = getCurrentInstance();
    const L = proxy.$getCurLanguage();
    const store = useStore()
    const router = useRouter();
    const afterSalesTitle = reactive({
      data: [
        {
          titleId: 1,
          content: L["仅退款"],
        },
        {
          titleId: 2,
          content: L["退货退款"],
        },
      ],
    });
    const curTitleId = ref(1); //当前选中的标题id
    const afterSalesList = reactive({ data: [] }); //售后列表
    const pageSize = ref(10);
    const current = ref(1);
    const aftersalesDetail = reactive({ data: {} }); //售后列表详情数据
    const showAllStoreOrders = ref(false);

    const toStore = storeId => {
      if (storeId == 0) {
        return
      }
      proxy.$goStoreDetail(storeId);
    };




    onMounted(() => {
      // 从localStorage恢复showAllStoreOrders状态
      const savedShowAllStoreOrders = localStorage.getItem('showAllStoreOrders');
      if (savedShowAllStoreOrders !== null) {
        showAllStoreOrders.value = JSON.parse(savedShowAllStoreOrders);
      }
      getAfterSalesDet();
    });
    router.beforeEach((to, from, next) => {
      // 从URL参数或localStorage恢复showAllStoreOrders状态
      if (to.query.showAllStore !== undefined) {
        showAllStoreOrders.value = to.query.showAllStore === '1';
      } else {
        const savedShowAllStoreOrders = localStorage.getItem('showAllStoreOrders');
        if (savedShowAllStoreOrders !== null) {
          showAllStoreOrders.value = JSON.parse(savedShowAllStoreOrders);
        }
      }

      if (to.query.type == "return") {
        curTitleId.value = 2; //退款退货
      } else {
        curTitleId.value = 1; //仅退款
      }
      getAfterSalesDet();
      next();
    });
    watchEffect(() => {
      let tmpPath = router.currentRoute.value.fullPath;
      if (tmpPath == '/member/order/aftersales?type=return' || tmpPath == '/member/order/aftersales?type=return&showAllStore=1') {
        curTitleId.value = 2; //退款退货
      } else if (tmpPath == '/member/order/aftersales' || tmpPath == '/member/order/aftersales?showAllStore=1') {
        curTitleId.value = 1; //我的退款
      }
    })
    //获取售后订单列表
    const getAfterSalesDet = () => {
      // 保存showAllStoreOrders状态到localStorage
      localStorage.setItem('showAllStoreOrders', JSON.stringify(showAllStoreOrders.value));

      let params = {
        returnType: curTitleId.value,
        current: current.value,
        pageSize: pageSize.value,
      };
      if (store.state.memberInfo.multipleStoresId !== 0) {
        params.multipleStoresId = showAllStoreOrders.value ? store.state.memberInfo.multipleStoresId : 0
      }
      proxy.$get("v3/business/front/after/sale/list", params).then((res) => {
        if (res.state == 200) {
          let result = res.data;
          aftersalesDetail.data = result;
          afterSalesList.data = result.list;
        } else {
          ElMessage.error(res.data);
        }
      });
    };
    //选择类型
    const titleNav = (titleId) => {
      curTitleId.value = titleId;
      // 更新路由以保持showAllStoreOrders状态
      const query = {};
      if (titleId === 2) {
        query.type = 'return';
      }
      if (showAllStoreOrders.value) {
        query.showAllStore = '1';
      }
      router.push({ path: '/member/order/aftersales', query });
      // 保持显示所有门店售后的选项状态
      current.value = 1; // 切换类型时重置页码
      getAfterSalesDet();
    };
    //上一页
    const handlePrevCilickChange = () => {
      current.value--;
      getAfterSalesDet();
    };
    //下一页
    const handleNextCilickChange = () => {
      current.value++;
      getAfterSalesDet();
    };
    //选择页面
    const handleCurrentChange = () => {
      getAfterSalesDet();
    };
    //查看售后详情
    const goRefundDetail = (afterSalesItem) => {
      router.push({
        path: "/member/order/refund/detail",
        query: {
          curTitleId: curTitleId.value,
          orderState: afterSalesItem.orderState,
          afsSn: afterSalesItem.afsSn,
        },
      });
    };
    //填写物流单号
    const logisticsBill = (afterSalesItem) => {
      router.push({
        path: "/member/order/logistics",
        query: {
          afsSn: afterSalesItem.afsSn,
        },
      });
    };
    //去商品详情页
    const goGoodsDetail = (productId) => {
      proxy.$goGoodsDetail(productId);
    };

    return {
      L,
      showAllStoreOrders,
      store,
      getAfterSalesDet,
      afterSalesTitle,
      curTitleId,
      afterSalesList,
      titleNav,
      pageSize,
      current,
      aftersalesDetail,
      handlePrevCilickChange,
      handleNextCilickChange,
      handleCurrentChange,
      goRefundDetail,
      logisticsBill,
      goGoodsDetail,
      toStore
    };
  },
};
</script>
<style lang="scss" scoped>
@import "../../../style/base.scss";
@import "../../../style/iconfont.css";
@import "../../../style/afterSalesList.scss";


.store-checkbox {
  position: relative;
  top: 60%;
  right: -30px; // 根据需要调整右边距
  transform: translateY(-70%);
  margin-left: 0;
  width: 100px;
  height: 30px;
  font-weight: bold;

  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: $colorMain;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: $colorMain;
    border-color: $colorMain;
  }

  .el-checkbox__inner::after {
    border-color: #fff;
  }
}
.multiple_stores_name {
  margin-left: 60px;
  cursor: pointer;
  color: $colorMain;
}

.storeName {
  color: #333;
  margin-left: auto;
  transform: translateX(-20px);
  &:hover {
    color: $colorMain;
  }
}
</style>
